import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import logo from "../../assets/images/logo.png";

export const Header = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div className="header" style={{ display: 'flex', width:'100%', justifyContent: 'space-between', alignItems: 'center', color: 'white', height: '60px' }}>
      <div className="hamburger-menu">
        <i className="fas fa-bars"></i>
      </div>
      <div className="logo">
        <img src={logo} alt="logo" width="150px"/>
      </div>
      <div style={{ display: 'flex', alignItems: 'right', gap: '16px' }}>
        <div className="notification">
          <i className="fas fa-bell"></i>
        </div>
        <button
          onClick={handleLogout}
          title="Sign Out"
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: 'white', fontSize: '18px', display: 'flex',
            alignItems: 'center', gap: '6px', padding: '4px 8px',
            borderRadius: '4px', transition: 'background 0.2s'
          }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.15)'}
          onMouseLeave={e => e.currentTarget.style.background = 'none'}
        >
          <i className="fas fa-sign-out-alt"></i>
          <span style={{ fontSize: '15px', fontFamily: 'Open Sans, sans-serif' }}>Sign Out</span>
        </button>
      </div>
    </div>
  );
};
